import ApiService from '@/services/api.service'

const UtilsService = {
  
  getExecuteSP(request) {
      return ApiService.post('/Utils/ExecuteSP', request); 
  },

  getUserRestrictions(userId) {
    return ApiService.get(`/Employees/UserRestrictions/${userId}`);
  }
}
  
export default UtilsService;